import script from "./TopicCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TopicCard.vue?vue&type=script&setup=true&lang=js"

import "./TopicCard.vue?vue&type=style&index=0&id=c826f98a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c826f98a"]])

export default __exports__